import { CURRENCY_SYMBOL } from '../../constants';

export const YOUR_BASKET = 'Your Basket';
// CHECKOUT - components > checkout
export const BASKET_DEAL_PRODUCT = {
  advisitoryDeliveryOption:
    'Based on your billing postcode, we’ve selected the required option for delivery to this address.',
  basedOnSharing: 'This deal is based on 2 people sharing',
  dateFlexibility:
    'Date Flexibility: Gift recipients choose their dates when redeeming their voucher. NB Further charges may apply on redemption if more expensive dates or options are chosen.',
  dealBasketMaxProduct: `You've already purchased the max quantity for these products. <strong>They will be removed at purchase.</strong>`,
  dealBasketOverlimitProduct:
    'You have reached the max quantity for these products in your basket. Please remove the products and add the allowed amount again. <strong> They will be removed at purchase.</strong>',
  dealBasketOverlimitProductMessage:
    'You have reached the max quantity for these products in your basket. Please remove the products and add the allowed amount again.',
  excludedTerritoriesPostcode:
    'Based on your billing postcode, we won’t be able to deliver to your location if you redeem for delivery to this address.',
};
export const BASKET_DEAL_PRODUCT_AVAILABLE_DATES = {
  getAvailableDatesText: (dates) => `${dates} dates available!`,
};
export const BASKET_DEAL_PRODUCT_DATES = {
  checkIn: 'Check In',
  checkOut: 'Check Out',
  date: 'Date',
  nights: 'Nights',
};
export const DELETE = 'Delete';
export const BASKET_DEAL_PRODUCT_DELIVERY = {
  getItBy: 'get it by',
  mustRedeemToday:
    'Redeem today for delivery by specified date. Delivery price per voucher.',
};
export const BASKET_DEAL_PRODUCT_DEPOSIT = {
  payDepositText: 'Pay Deposit:',
  payFull: 'Pay Full Amount:',
};
export const BASKET_DEAL_PRODUCT_GIFTING = {
  giftingOptions: 'Gifting Options',
  showGiftingInfo: 'Show gifting information',
};
export const BASKET_DEAL_PRODUCT_MERCHANT_AMOUNT = {
  depositPayToMerchant: 'to be paid to merchant',
};
export const BASKET_DEAL_PRODUCT_META = {
  deposit: 'Deposit',
  now: 'Now',
  quantity: 'Quantity',
  save: 'Save',
  saveUpto: 'Save up to',
  subtotal: 'Subtotal',
};
export const BASKET_DEAL_PRODUCT_QUANTITY = {
  delete: 'Delete',
  selectQuantity: 'Select Quantity',
};
export const CUE_ATOL_PROTECTED =
  'ATOL Protected - Financial protection through the UK ATOL Scheme';
export const ATOL_LOGO_ALT = 'Atol logo';
export const CUE_ATOL_INSTANT = 'Instant Booking - No redemption required';
export const BASKET_SOCIAL_CUES_NON_ATOL = {
  changeYourMind:
    'Change your mind? You can redeem this towards any other deal on site',
  noQuibble: 'No quibble 14 day refund guarantee on unredeemed vouchers',
};
export const EMPTY_BASKET = {
  browseGreatDealsAnd: `Browse some of our great deals and add them to your basket today.`,
  browseGreatDealsOr: 'Browse some of our great deals or',
  continueShopping: 'Continue Shopping',
  login: 'Login',
  toSeeSavedItems: 'to see saved items.',
  yourBasketIsEmpty: 'Your basket is empty!',
};
export const GIFTING_INFO_MODAL = {
  eGiftAlt: 'eGift example',
  eGiftingIncludes: 'e-Gifting',
  eGiftingIncludesBullets: [
    'Personalised message',
    'A link for your recipient to claim their gift',
    'PDF of your chosen gift with highlights and images for your recipient',
  ],
  giftingBrand: 'Gifting @ 5pm',
  giftingWowcher: '',
  giftPackAlt: 'Gift pack example',
  giftPackIncludes: 'Gift Pack',
  giftPackIncludesBullets: [
    { label: 'Sleek, pink, presentation wallet' },
    { label: 'Personalised message' },
    { label: 'Highlights and images from your chosen gift' },
    {
      label: 'Delivery:',
      subItems: ['Standard Delivery: Within 3-5 working days'],
    },
  ],
  giftWrapAlt: 'Gift wrap example',
  giftWrapIncludes: 'Gift Wrap',
  giftWrapIncludesBullets: [
    'Your present will arrive in a Christmas themed bag at your recipients address',
    'Every bag will have a ribbon closure',
    'We will ensure the best sized bag is chosen for your gift',
    'Each sized bag has a different Christmas design',
    'You can include a personalised message',
    'Your message will be printed and attached to the bag',
  ],
  pinkImmediateDelivery: 'Immediate delivery',
  viaEmail: 'via email',
};
export const GO_BACK = 'Go Back';
export const REGISTER_NOTIFICATION =
  'You can confirm your delivery address once you place your order';
export const TIMER = {
  pricesConfirmed: 'Availability confirmed!',
  refreshing: 'Refreshing',
  timeRemaining: 'Availability re-checked in',
};

export const TIMER_RESERVATION = {
  reservedEndMessage: 'Products no longer reserved',
  reservedMessage: 'Products reserved in your basket at this price for',
};
export const VIP_INFO_MODAL = {
  bulletPointBonusCredit: (creditAmount, currencySymbol) =>
    `Get ${currencySymbol}${creditAmount} credit at every renewal - don't miss out!`,
  bulletPoints: [
    'Exclusive credit & discount codes - worth over ##currency##50 per year!',
    'Automatic entry to all of our competitions - you"ll be in with a chance to win amazing prices & holidays worth over ##currency##20,000!',
    'Exclusive access to limited availability deals',
    'Premier customer service - Guaranteed 24hr response',
  ],
  infoText:
    'And we promise to refund you if VIP isn’t for you - we offer a 14 day no quibble refund!',
  infoTitle: 'Become a VIP and you will receive:',
  quickBuy: 'Quick Buy',
  tnc: 'View VIP T&Cs',
};
export const WOWCHER_VIP_CUE = {
  socialCue: `YOU'RE A`,
  socialCueAlt: 'vip logo',
};
export const AUTOCOMPLETE_PROMPT = 'Start typing an address...';
export const YOUR_DETAILS = 'Your Details';
export const FORM_EMAIL = 'Email';
export const FORM_PASSWORD = 'Password';
export const REGISTRATION_FIRST_NAME = 'First Name';
export const REGISTRATION_LAST_NAME = 'Last Name';
export const REGISTER_ENTER_VALID_EMAIL = 'Enter a valid email';
export const REGISTRATION_ADDRESS = 'Postcode';
export const LOOKUP_ADDRESS = 'Lookup address';
export const REGISTER_ENTER_VALID_POSTCODE = 'Enter a valid postcode';
export const REGISTER_VERIFY_POSTCODE = 'Invalid postcode';
export const REGISTRATION_CONFIRM_PASSWORD = 'Confirm Password';
export const REGISTRATION_RULE = 'minimum 6 characters';

export const DETAILS_BILLIND_ADDRESS = 'Billing address';
export const DETAILS_CHANGE_ADDRESS = 'Change address';
export const DETAILS_CHANGE_POSTCODE = 'Change postcode';
export const DETAILS_UPDATE_ADDRESS = 'Update address';
export const DETAILS_UPDATE_POSTCODE = 'Update postcode';
export const DETAILS_ADD_ADDRESS = 'Add address';
export const DETAILS_ADD_POSTCODE = 'Add postcode';
export const BUTTON_CANCEL = 'Cancel';
export const REQUIRED_FIELD = 'Required field';
export const DETAILS_ADDRESS_IS_UPDATED = `Billing address updated successfully!`;
export const DETAILS_ADDRESS_UPDATE_ERROR = `Billing address wasn't updated`;

export const LOOKUP_OR_ENTER_ADDRESS = 'Lookup address or enter one manually';
export const REGISTER_MATCH_PASSWORD = 'Passwords should match';
export const SOCIAL_MESSAGE = 'It only takes a minute...';

// user login title

export const DETAIL_LOGIN = 'Login';
export const FIRST_TIME_BUYER_LINK = 'First time buyer?';
export const REGISTER_HERE = 'Register here';

// user registration title
export const DETAIL_LOGIN_HERE = 'Login here';
export const FIRST_TIME_BUYER = 'Your details';

export const CREDIT = {
  expMsgPurchase: (value) => `Use ${value} of my credit for this purchase`,
  msgAllowed: ' with a promo code)',
  msgCannot: (value) => `(${value} marketing credit cannot be used`,
  msgLarge: (totalWallet, amountInWallet) =>
    `Use ${totalWallet} of my ${amountInWallet} credit for this purchase`,
  msgNotAllowed: ' for this purchase)',
  msgPurchase: (value) => `Use my ${value} credit for this purchase`,
  msgZero: (value) => `Use my ${value} credit for this purchase`,
};

export const ORDER_SUMMARY = {
  socialCuesMayIncrease: 'This price may increase if you buy later',
  title: 'Order Summary',
};

export const PROMO = {
  add: 'Add promo code',
  apply: 'APPLY',
  notAuthenticated: 'Please register or log in to apply promo code',
  placeholder: 'PROMO CODE',
  remove: 'REMOVE',
};

export const MARKETING_CREDIT_INFO = `Please note - Promotional Marketing Credit is limited to 10% (up to ${CURRENCY_SYMBOL}5) per eligible basket item.`;
export const PREFORMATTED_STRING = {
  brandTerminology: {
    brand: '5pm',
    wowcher_or_voucher: 'voucher',
    Wowcher_or_voucher: 'voucher',
    wowchers_or_vouchers: 'vouchers',
    Wowchers_or_vouchers: 'vouchers',
  },
};

export const REDEEM_CODE_BTN_CONFIRM = 'Confirm';
export const REDEEM_CODE_ORDER_NO = 'Order Number:';
export const REDEEM_CODE_WOWCHER_CODE = (value) => `${value} Code:`;
export const REDEEM_CODE_UNUSED_WOWCHER = (value) =>
  `Redeem an unused ${value} code towards this purchase`;

// Order Summary - components > checkout > ordersummary
export const SUMMARY = {
  adminFee: 'Administration fee:',
  balanceOf: 'Balance of ',
  congratulations: 'Congratulations, ',
  creditApplied: 'Credit applied:',
  giftPack: 'Gift Pack including postage:',
  giftPackExpress: 'Gift Pack - Next Day Delivery:',
  giftPackStandard: 'Gift Pack - Standard Delivery:',
  giftWrap: 'Gift wrap:',
  merchant: ' to be paid to merchant(s)',
  postageCalculated: 'How is postage calculated?',
  postageCharge: (value) =>
    `We will only charge for postage on the ${value} items with the most expensive postage. The rest comes free!`,
  postageDiscount: 'Add more items to receive a discount on postage',
  postPackaging: 'Post & Packaging:',
  promoDiscount: (discount) => `Promo code (${discount}%):`,
  subtotal: 'Subtotal:',
  totalPayToday: 'Total to pay today:',
  totalToPay: 'Total to pay:',
  totalToPayNonVip: 'Total to Pay: Non-VIP',
  totalToPayVip: 'Total to pay + VIP:',
  vipDoubleDiscount: 'Discount!',
  vipWelcomeDiscount: 'VIP welcome discount:',
  wowcherVipSocialCueAlt: 'vip logo',
  youSaved: 'you have saved:',
};

export const VIP_SUBSCRIBE = {
  vipExclusiveInfo:
    'A year of VIP has been added to your basket as you have chosen to benefit from an exclusive deal',
  vipSubscribeTitle: 'One year of VIP for just',
};

export const VIP_SUBSCRIBE_CHECKBOX = {
  vipExclusiveInfo:
    'A year of VIP has been added to your basket as you have chosen to benefit from an exclusive deal',
  vipSubscribeTitle: 'One year of VIP for just',
};

// Passenger Details - components > checkout > passengerdetails
export const PASSENGER = {
  heading: (value) => `Passenger ${value}`,
  labelDob: 'Date of Birth',
  placeholderFirstName: 'First name(s)*',
  placeholderLastName: 'Last Name*',
  placeholderYears: 'Year* (YYYY)',
  selectDays: 'Day*',
  selectMonths: 'Month*',
  selectTitles: [
    { name: 'Title*', value: '' },
    { name: 'Mr', value: 'Mr' },
    { name: 'Mrs', value: 'Mrs' },
    { name: 'Ms', value: 'Ms' },
    { name: 'Miss', value: 'Miss' },
  ],
};

export const PASSENGER_DETAILS = {
  heading: 'Passenger Details',
  labelContactNo: 'Contact Phone Number',
  note: 'Please add the passenger details as they appear on your passports.',
  placeholderContactNo: 'Phone number*',
  required: '*required field',
};

export const APPLE_BUTTON_IMG_TEXT = 'Apple Pay';
export const APPLE_BUTTON_TEXT = 'Pay with Apple Pay';
export const BUTTON_GO_TO_PAYMENT = 'GO TO PAYMENT';

export const CARD_BUTTON_TEXT = 'Pay with Card';
export const CARD_BUTTON_IMG_TEXT = 'Credit Card';
export const CARD_ERROR_EXPIRED = 'Card Expired';
export const CLEARPAY_BUTTON_IMG_TEXT = 'Clearpay';
export const GOOGLE_BUTTON_TEXT = 'Pay with Google Pay';
export const GOOGLE_BUTTON_IMG_TEXT = 'Google Pay';
export const KLARNA_BUTTON_IMG_TEXT = 'Klarna';

// payment

export const PAYMENT = 'Payment';
export const ERROR_USING_PAYPAL_AND_WALLET =
  'Your entire order uses wallet credit. For security reasons please follow the card payment flow below';
export const PAYMENT_ADDRESS_MESSAGE =
  'Add your full address to complete purchase.';
export const PAYMENT_ADDRESS_MESSAGE_POSTCODE =
  'Add your postcode to complete purchase.';
export const PAYMENT_LOGIN_MESSAGE = 'Login or register to complete purchase.';
export const PAYMENT_NO_PURCHASABLE_MESSAGE =
  'You have no purchasable products in your basket.';
export const PAYMENT_PASSENGER_DETAILS_MESSAGE =
  'Please provide valid passenger details to complete purchase.';

export const CHECKOUT_PAYMENT_COMPONENT = {
  PaymentAgreeTerms: {
    agreeText: 'I agree to the',
    ecommerceLinkText: 'E-Commerce Terms',
  },
  paymentApple: {
    buttonText: 'Pay with',
    errorBraintree:
      'We had a problem completing your request, please continue your purchase or try again later',
    errorDefaultPayment:
      'There was a problem with your payment and your order has not been placed. Please check your details and try again. If the issue persists please contact us for assistance.',
    formMessage:
      "Tap the 'Apple Pay' button below and confirm your purchase with Touch ID or Face ID on your Apple device.",
    imageText: 'Apple Pay',
    vipPayButtonMessage: 'Please select one of the options above.',
    vipPayButtonMessageSelected:
      'Use the button below to complete this purchase.',
    vipPayExclusiveButton: 'Please select the option above.',
    vipPayExclusiveDeal:
      'To benefit from your VIP exclusive deal, an active VIP membership is required.',
  },
  paymentGoogle: {
    errorBraintree:
      'We had a problem completing your request, please continue your purchase or try again later',
    errorDefaultPayment:
      'There was a problem with your payment and your order has not been placed. Please check your details and try again. If the issue persists please contact us for assistance.',
    formMessage: "Tap the 'Google Pay' button below and confirm your purchase.",
    imageText: 'Google Pay',
    liabilityError:
      'Unfortunately, your payment did not go through. Please try again or select a different payment method',
    vipPayButtonMessage: 'Please select one of the options above.',
    vipPayButtonMessageSelected:
      'Use the button below to complete this purchase.',
    vipPayExclusiveButton: 'Please select the option above.',
    vipPayExclusiveDeal:
      'To benefit from your VIP exclusive deal, an active VIP membership is required.',
  },
  paymentPaypal: {
    errorBraintree:
      'We had a problem completing your request, please continue your purchase or try again later',
    errorDefaultPayment:
      'There was a problem with your payment and your order has not been placed. Please check your details and try again. If the issue persists please contact us for assistance.',
    redirectionPaypalMessage:
      'You will be redirected to PayPal to complete the payment.',
    vipPayButtonMessage: 'Please select one of the options above.',
    vipPayButtonMessageSelected:
      'Use the button below to complete this purchase.',
    vipPayExclusiveButton: 'Please select the option above.',
    vipPayExclusiveDeal:
      'To benefit from your VIP exclusive deal, an active VIP membership is required.',
  },
  paymentSummary: {
    basketItems: 'items',
    basketTotal: 'Basket Total',
  },
};

// vipToggleButtons
export const BUTTON_BUY_WITH_VIP = 'place your order + vip';
export const VIP_RADIO_HEADING = 'purchase options';
export const BUTTON_PLACE_ORDER = 'PLACE YOUR ORDER';

export const VIP_BELOW_CTA =
  'You may purchase either with or without VIP. If you select the option with VIP, the price of your basket will be reduced so that the total price you pay will be no more than the total price without VIP.';
export const PAYPAL_BUTTON_TEXT = 'Pay with PayPal';
export const PAYPAL_BUTTON_IMG_TEXT = 'PayPal';

// paymentSavedCardBT
export const CARD_TOGGLE_ANOTHER_PRE = 'Or ';
export const CARD_TOGGLE_ANOTHER_LINK = 'use another card';
export const CARD_TOGGLE_ANOTHER_DATA_QA = 'changeCard';
export const CARD_TOGGLE_SEE_ALL_CARDS = 'see all your cards';
export const DEFAULT_PAYMENT_ERROR =
  'There was a problem with your payment and your order has not been placed. Please check your details and try again. If the issue persists please contact us for assistance.';
export const LIABILITY_ERROR = `Unfortunately, your payment did not go through. Please try again or select a different payment method`;
export const BECOME_A_VIP = 'Become a VIP';
export const VIP_PAY_EXCLUSIVE_DEAL_MESSAGE =
  'To benefit from your VIP exclusive deal, an active VIP membership is required.';
export const VIP_WITHOUT_UNAVAILABLE =
  'This option is unavailable as the deal you have selected requires a VIP membership';

// Payment - components > checkout > payment
export const PAYMENT_MESSAGE = {
  notProcess: 'We could not process your payment',
  oopsPayment: 'Oops! Payment Failed',
  tryAgainPlease:
    'Try again. Please select a different payment method below or pay using another card',
};

// klarna
export const KLARNA_DISABLED_HOVER_MESSAGE = `Please enter a valid Postcode to continue`; // Postcode changes to eircode on IE sites
export const KLARNA_DISABLED_MESSAGE =
  'Please complete the Your Details section before proceeding.';
export const WARNING_POSTAGE_OPTION = `Click and Collect orders will need to be picked up from our collection point in Derby. <br>Address: Wowcher, Pentagon House, Sir Frank Whittle Road, Derby DE21 4XA. <br>This is our <b>only</b> collection point. Collections are available between 9am to 5pm, Monday to Friday excluding bank holidays.`;
export const NO_QUIBBLE =
  'No quibble 14 day refund guarantee on unredeemed vouchers';
export const ERROR_MESSAGE_KLARNA =
  'We had a problem completing your Klarna payment, please try again or use a different payment method';
export const VIP_PAY_BUTTON_MESSAGE = 'Please select one of the options above.';
export const VIP_PAY_BUTTON_MESSAGE_EXCLUSIVE =
  'Please select the option above.';
export const VIP_PAY_BUTTON_MESSAGE_SELECTED =
  'Use the button below to complete this purchase.';
export const CLICK_COLLECT_TNC =
  'https://help.wowcher.co.uk/en_GB/articles/faqs/delivery-click-collect/63c7e40ce221e76974afe894';

// paymentCardBT
export const CARD_ERROR_DATE_NOT_VALID = 'This expiry date is not valid';
export const CARD_ERROR_INVALID = "Hmm. That card number doesn't look right";
export const CARD_ERROR_TYPES =
  'Sorry, we currently only accept Visa and MasterCard';
export const CARD_INPUT_DATA_QA = 'cardNumber';
export const CARD_TOGGLE_SAVED_DATA_QA = 'useSavedCard';
export const CARD_TOGGLE_SAVED_LINK = 'use your saved card';
export const CARD_TOGGLE_SAVED_PRE = 'You can also ';
export const CVV_ERROR_REQUIRED = 'Security code is required';
export const ERROR_MESSAGE_BRAINTREE =
  'We had a problem completing your request, please continue your purchase or try again later';
export const POSTAL_CODE_REQUIRED = 'Postal code is required';

// clearpay

export const ERROR_MESSAGE_CLEARPAY =
  'We had a problem completing your Clearpay payment, please try again or use a different payment method';
export const CLEARPAY_DISABLED_MESSAGE =
  'Please complete the Your Details section before proceeding.';
export const CONTRACT_DISCLAMER_TEXT =
  'I understand that, once I redeem a voucher, a separate contract is formed between the merchant and me.';
